<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="primary" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Nueva ingreso/egreso
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" md="8" sm="4" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar ingreso/egreso" single-inline hide-details
                        @keydown.enter="searchTransaction" placeholder="Buscar por folio, descripcion">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <v-tooltip left color="success">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon class="mt-4 ml-2" color="success" v-bind="attrs" v-on="on" dark @click.prevent="handleTransactionReport">
                                    <v-icon dark left>fas fa-file-pdf</v-icon>
                                </v-btn>
                            </template>
                            <span>Reporte de transacciones</span>
                        </v-tooltip>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>
                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="transactions" class="elevation-1" fixed-header color="primary"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                    <template v-slot:[`item.actions`]="{ item }">
                        <ActionTransaction :item="item" :edit-transaction="editTransaction" :initialize-transaction.sync="initTableTransaction"
                        :today="getToday" />
                    </template>
                    <template v-slot:[`item.deleted`]="{ item }">
                        <v-chip small x-small dark v-text="!item.deleted ? 'Activo' : 'Inactivo'" :color="!item.deleted ? 'success' : 'error'">
                        </v-chip>
                    </template>
                    <template v-slot:[`item.isCashRegister`]="{ item }">
                        <v-chip small label x-small dark
                        v-text="!item.isCashRegister ? 'No Efectuado' : 'Si'">
                        </v-chip>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
        <FormTransaction :transaction-id.sync="transactionId" :initialize.sync="initTableTransaction"
        :transaction-type="transactionType" :transaction-category="transactionCategory" :payment-method="paymentMethod"
        :lstCashRegister="lstCashRegister" :has-cash-register-opened="hasCashRegisterOpened"
        :handleDialog="handleDialog" :dialog.sync="dialog" v-if="dialog" />
        <TransactionReport :dialog.sync="dialogTransactionReport"
        :handle-modal="handleTransactionReport" :brands.sync="brands"
        v-if="dialogTransactionReport" />
    </v-row>
</template>
<script>
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import FormTransaction from './FormTransaction.vue';
import TransactionRecordService from '@/service/transactions/TransactionRecordService';
import TransactionCategoryService from '@/service/transactions/TransactionCategoryService';
import CashRegisterDataService from '@/service/cashRegister/CashRegisterDataService';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import { getToday } from '@/utils/DateUtil';
import ActionTransaction from './ActionTransaction.vue';
import TransactionReport from './TransactionReport.vue';
import { extractMessage } from '@/helpers/errorHelper';
export default {
    name: 'ListaTransaction',
    mixins: [pagedTableMixin],
    components: { Columns, FormTransaction, ActionTransaction, TransactionReport, PaginationNumber },
    created() {
        this.fetchTableData();
        this.getTransactionCategory();
        this.findCashRegisterOpenedBySucursal();
        this.getAllSucursal();
    },
    data() {
        return {
            transactionType: [
                { text: 'Ingreso', value: 'INCOME' },
                { text: 'Egreso', value: 'EXPENSE' }
            ],
            lstCashRegister: [],
            paymentMethod: [ 'EFECTIVO', 'TRANSFERENCIA', 'CHEQUE'],
            transactionCategory: [],
            transactions: [],
            brands: [],
            headers:[
                { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true },
                { text: 'ID', align: " d-none", value: 'id', visible: false, sortable: false, groupable: false, show: false },
                { text: 'Folio', value: 'folio', sortable: false, groupable: false, show: true },
                { text: 'Tipo transaccion', value: 'transactionTypeNatural', sortable: false, groupable: false, show: true },
                { text: 'Categoria', value: 'transactionCategoryName', sortable: false, groupable: false, show: true },
                { text: 'Fecha transacción', value: 'registerDateNatural', sortable: false, groupable: false, show: true },
                { text: 'Descripcion', value: 'description', sortable: false, groupable: false, show: true },
                { text: 'Monto', value: 'amount', sortable: false, groupable: false, show: true },
                { text: 'Caja', value: 'isCashRegister', sortable: false, groupable: false, show: true },
                { text: 'Folio caja', value: 'cashRegisterTicket', sortable: false, groupable: false, show: true },
                { text: 'Estatus', value: 'deleted', sortable: false, groupable: false, show: true },
            ],
            transactionId: null,
            dialog: false,
            dialogTransactionReport: false,
        }
    },
    methods:{
        searchTransaction(){
            this.doSearch();
        },
        fetchTable(params){
            return TransactionRecordService.table( params );
        },
        applyRows({ rows, total, totalPages }){
            this.transactions = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableTransaction(){
            this.reload();
        },
        async getTransactionCategory(){
            this.transactionCategory = await TransactionCategoryService.findAll().then( resp => resp.data )
        },
        async getAllSucursal(){ this.brands = await SucursalDataService.lstSucursal().then( resp => resp.data ) || [] },
        editTransaction({id}){
            this.transactionId = id;
            this.dialog = true;
        },
        handleDialog(){
            this.dialog = !this.dialog;
            this.transactionId = null;
        },
        findCashRegisterOpenedBySucursal() {
            CashRegisterDataService.findCashRegisterBySucursal().then(response => {
                this.lstCashRegister = response.data;
            })
        },
        handleTransactionReport() {
            this.dialogTransactionReport = !this.dialogTransactionReport
        }
    },

    computed: {
        filteredHeaders() { return this.headers.filter(h => h.show); },
          // To validate if the user has cash register opened at least one.
        getSucursalId() { return SucursalDataService.getCurrentSucursalId(); },
        hasCashRegisterOpened() {
            if(this.lstCashRegister.length === 0) return false;
            const today = getToday().toFormat('dd/MM/yyyy');
            return this.lstCashRegister.filter(cashRegister => cashRegister.status === 'OPENED' && cashRegister.opened === today).length > 0;
        },
        getCashRegisterOpenedByUser() {
            if(this.lstCashRegister.length === 0) return [];
            const today = getToday().toFormat('dd/MM/yyyy');
            return this.lstCashRegister.filter(cashRegister => cashRegister.status === 'OPENED' && cashRegister.opened !== today);
        },
        getToday() { return getToday().toFormat('dd/MM/yyyy'); },
    }
}
</script>